import { useState, useEffect } from 'react';
import { Storage } from 'aws-amplify';

/**
 * Hook that resolves an S3 image key to a signed URL for avatar display.
 * Returns null while loading or if the imageName is empty/invalid.
 */
export function useAvatar(imageName?: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!imageName || imageName === '') {
      setUrl(null);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const signedUrl = await Storage.get(imageName);
        if (!cancelled && signedUrl && signedUrl !== '') {
          setUrl(signedUrl as string);
        }
      } catch (err) {
        console.error('[useAvatar] Error resolving avatar URL:', err);
        if (!cancelled) {
          setUrl(null);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [imageName]);

  return url;
}
